import React, { useState, useEffect } from "react";
import api, { API_URL, BACKEND_URL } from "../util/api";
import "./HeroSlider.css";
import { Link } from "react-router-dom";

export default function HeroSlider() {

  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);
  const [youtubeLink, setYoutubeLink] = useState("");
  const [facebookLink, setFacebookLink] = useState("");
  const [activePlatform, setActivePlatform] = useState("none");
  const [playVideo, setPlayVideo] = useState(false);


  useEffect(() => {

    api.get(API_URL + "/sliders")
      .then(res => {

        

        if (res.data.success === true) {

          setSlides(res.data.slides);
          setYoutubeLink(res.data.youtube_link);
          setFacebookLink(res.data.facebook_link);
          setActivePlatform(res.data.active_platform);

        }else{

          
        }

      })
      .catch(err => {
        console.log(err);
      })

  }, []);


  const next = () => {
    setIndex(prev => (prev + 1) % slides.length)
  }

  const prev = () => {
    setIndex(prev => prev === 0 ? slides.length - 1 : prev - 1)
  }


  useEffect(() => {

    if (slides.length === 0) return;

    const timer = setInterval(() => {
      next()
    }, 6000)

    return () => clearInterval(timer)

  }, [slides, index])


  /* ---------------------------
     Convert YouTube Link
  --------------------------- */

  const getYoutubeEmbed = (url) => {

    if (!url) return "";

    const regExp = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/;
    const match = url.match(regExp);

    return match
      ? `https://www.youtube.com/embed/${match[1]}?autoplay=1&mute=1`
      : url;
  };


  /* ---------------------------
     FACEBOOK LIVE
  --------------------------- */

  const getFacebookEmbed = (url) => {

    if (!url) return "";

    return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false&autoplay=true`;

  };


  /* ===============================
      SHOW LIVE STREAM INSTEAD
  =============================== */

  if (activePlatform !== "none") {

    return (

      <div className="live-container">

        <div className="live-header">
          <h2>🔴 RCCG YAYA Province 12 Live Service</h2>
          <p>Join us live and be blessed</p>
        </div>

        <div className="video-wrapper">

          {!playVideo && (
            <div className="video-overlay" onClick={() => setPlayVideo(true)}>

              <div className="play-button">
                ▶
              </div>

              <div className="live-label">
                LIVE STREAM
              </div>

            </div>
          )}

          {playVideo && activePlatform === "youtube" && (

            <iframe
              src={getYoutubeEmbed(youtubeLink)}
              title="YouTube Live"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />

          )}

          {playVideo && activePlatform === "facebook" && (

            <iframe
              src={getFacebookEmbed(facebookLink)}
              title="Facebook Live"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />

          )}

        </div>

      </div>

    )

  }


  /* ===============================
      NORMAL SLIDER (UNCHANGED)
  =============================== */

if (slides.length === 0) {

  return (

    <div className="hero-loading">

      <div className="loading-slide">

        <div className="loading-image shimmer"></div>

        <div className="loading-content">

          <div className="loading-title shimmer"></div>

          <div className="loading-text shimmer"></div>

          <div className="loading-btn shimmer"></div>

        </div>

      </div>

    </div>

  )

}

  return (

    <div className="hero-slider">

      {slides.map((slide, i) => (

        <div
          key={i}
          className={`slide ${i === index ? "active" : ""}`}
        >

          <div
            className="blur-bg"
            style={{
              backgroundImage: `url(${BACKEND_URL + slide.image})`
            }}
          />

          <img
            src={BACKEND_URL + slide.image}
            alt={slide.title}
            loading="lazy"
            className="main-image"
          />

          <div className="overlay"></div>

          <div className="content">

            <h1>{slide.title1}</h1>

            <p>{slide.subtitle}</p>

            {slide.url != null && (

              <Link to={slide.url}>

                <button className="btn">
                  {slide.text1}
                </button>

              </Link>
            )

            }

          </div>

        </div>

      ))}

      <div className="arrow left" onClick={prev}>‹</div>
      <div className="arrow right" onClick={next}>›</div>

    </div>

  )

}